import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import User from './utils/user.js';
import ApiClient from './utils/apiClient.js';
import Cache from './utils/cache.js';

const user = new User();
const apiClient = new ApiClient(user);
const cache = new Cache();

const App = lazy(() => import('./routes/app.js'));
const Login = lazy(() => import('./routes/login.js'));

window.onload = function() {
  var fillColor = 'red';
  switch(process.env.REACT_APP_STAGE) {
    case 'review': fillColor = 'red'; break;
    case 'sandbox': fillColor = 'orange'; break;
    case 'staging': fillColor = '#29abe2'; break;
    case 'production': return false;
    default: fillColor = 'red'; break;
  }
  var favicon = document.getElementById('favicon');
  var faviconSize = 16;

  var canvas = document.createElement('canvas');
  canvas.width = faviconSize;
  canvas.height = faviconSize;

  var context = canvas.getContext('2d');
  var img = document.createElement('img');
  img.src = favicon.href;

  img.onload = () => {
      // Draw Original Favicon as Background
      context.drawImage(img, 0, 0, faviconSize, faviconSize);

      // Draw Notification Circle
      context.beginPath();
      context.arc( faviconSize / 2, faviconSize / 2 - faviconSize / 4, faviconSize / 5, 0, 2*Math.PI);
      context.fillStyle = fillColor;
      context.fill();

      // Replace favicon
      favicon.href = canvas.toDataURL('image/png');
    };
};


const app = user.isAuthenticated ? (
      <Suspense fallback={<div className='loading-indicator'>Loading app...</div>}>
        <App user={user} apiClient={apiClient} cache={cache}/>
      </Suspense>
    ) : (
      <Suspense fallback={<div className='loading-indicator'>Loading login page...</div>}>
        <Login user={user} apiClient={apiClient}/>
      </Suspense>
    )

ReactDOM.render(app, document.getElementById('root'))
